"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _chrome = _interopRequireDefault(require("./chrome.svg"));

var _firefox = _interopRequireDefault(require("./firefox.svg"));

var BrowserWarningMessageDE = function BrowserWarningMessageDE(_ref) {
  var onBrowserSelect = _ref.onBrowserSelect;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-center padding-right-1pct padding-left-1pct'
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: 'margin-bottom-25 padding-top-25'
  }, 'Sie nutzen einen veralteten Browser'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18 margin-bottom-25'
  }, 'Der ', /*#__PURE__*/_react.default.createElement("b", null, 'Internet Explorer'), ' ist mit seinen knapp 7 Jahren nun langsam ins hohe Alter gekommen und kann ', 'in Sachen ', /*#__PURE__*/_react.default.createElement("b", null, 'Schnelligkeit'), ', ', /*#__PURE__*/_react.default.createElement("b", null, 'Features'), ' aber vor allem in Punkto ', /*#__PURE__*/_react.default.createElement("b", null, 'Sicherheit'), ', nicht mehr mit modernen Browsern mithalten.'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18 margin-bottom-25'
  }, 'Wir bei RIO haben uns das Ziel gesetzt, Ihnen die ', /*#__PURE__*/_react.default.createElement("b", null, 'bestmögliche Software'), ' bereitzustellen um Ihnen ein ', /*#__PURE__*/_react.default.createElement("b", null, 'optimales Nutzungserlebnis'), ' zu bieten. Daher haben wir uns dazu entschlossen den Support für ', 'den IE11 einzustellen.'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18'
  }, /*#__PURE__*/_react.default.createElement("b", null, 'Erleben Sie RIO von einer ganz neuen Seite, z.B. mit einem der folgenden Browser:'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "display-flex justify-content-center justify-content-around flex-wrap\n                padding-right-2pct-ls padding-left-2pct-ls"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: 'https://www.google.com/chrome/',
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'display-block hover-scale-110',
    onClick: function onClick() {
      return onBrowserSelect('chrome');
    }
  }, /*#__PURE__*/_react.default.createElement(_chrome.default, null)), /*#__PURE__*/_react.default.createElement("a", {
    href: 'https://www.mozilla.org/firefox/new/',
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'display-block hover-scale-110',
    onClick: function onClick() {
      return onBrowserSelect('firefox');
    }
  }, /*#__PURE__*/_react.default.createElement(_firefox.default, null))));
};

var _default = BrowserWarningMessageDE;
exports.default = _default;